import { memo, useMemo } from "react";
import AudioPlayerSource from "src/components/(audio-player)/AudioPlayerSource";
import LazyAudioPlayer from "src/components/(audio-player)/LazyAudioPlayer/LazyAudioPlayer";
import { useGatheringStore } from "src/contexts/GatheringContext";

const GatheringHomeAddonAudioPlayer = () => {
	const addons = useGatheringStore((state) => state.addons);
	const audioPlayerAddonArgs = useMemo<{
		thumbnailUrl: string;
		audioUrl: string;
	} | null>(() => {
		const audioPlayerAddon = addons?.find((addon) => addon?.audioUrl && addon?.icon);
		if (!audioPlayerAddon || !audioPlayerAddon.audioUrl || !audioPlayerAddon.icon) {
			return null;
		}
		return {
			thumbnailUrl: audioPlayerAddon.icon,
			audioUrl: audioPlayerAddon.audioUrl,
		};
	}, [addons]);

	return (
		<>
			{audioPlayerAddonArgs && (
				<AudioPlayerSource
					audioUrl={audioPlayerAddonArgs.audioUrl}
					thumbnailUrl={audioPlayerAddonArgs.thumbnailUrl}
				/>
			)}
			<LazyAudioPlayer />
		</>
	);
};
export default memo(GatheringHomeAddonAudioPlayer);
